export default function initResultadosArtigosSlider() {
    const swiperContainer = document.querySelector('.c-search-news__swiper');

    if (!swiperContainer) return;

    const relatedNewsSwiper = new Swiper(swiperContainer, {

        slidesPerView: 1.1,
        spaceBetween: 15,
        grabCursor: true,
        slidesOffsetBefore: 20,
        slidesOffsetAfter: 20,
        watchOverflow: true,

        a11y: {
            enabled: true,
            prevSlideMessage: 'Slide anterior',
            nextSlideMessage: 'Próximo slide',
            firstSlideMessage: 'Este é o primeiro slide',
            lastSlideMessage: 'Este é o último slide',
            paginationBulletMessage: 'Ir para o slide {{index}}',
        },

        navigation: {
            nextEl: '.c-search-news__arrow--next.js-search-news-next',
            prevEl: '.c-search-news__arrow--prev.js-search-news-prev',
        },

        pagination: {
            el: '.c-search-news__pagination',
            clickable: true,
        },

        breakpoints: {
            992: {
                slidesPerView: 3,
                spaceBetween: 20,
                slidesOffsetBefore: 0,
                slidesOffsetAfter: 0,
            }
        }
    });

    return relatedNewsSwiper;
}